export default {
  data() {
    return {
      submitFunction: 'submitForm',
      _submitData: null
    };
  },
  methods: {
    validateForm(submitData) {
      if (!this.validates) {
        throw new Error('validates 변수가 존재하지 않습니다.');
      }

      if (submitData) {
        this._submitData = submitData.data;
      }

      Object.values(this.validates).forEach(validate => {
        validate.isValidated = !this[validate.validateFunction]();
      });

      this.consumeDialog();
    },

    consumeDialog() {
      let notValidates = Object.values(this.validates).filter(
        validate => !validate.isValidated
      );

      if (notValidates.length > 0) {
        notValidates[0].dialogVisible = true;
      } else {
        this[this.submitFunction || 'submitForm'](this._submitData);
      }
    },

    onConfirmValidateDialog(validateName) {
      this.validates[validateName].dialogVisible = false;
      this.validates[validateName].isValidated = true;
      this.consumeDialog();
    },

    onCancelValidateDialog(validateName) {
      this.validates[validateName].dialogVisible = false;
      if ('dialogActionButtons' in this.$refs) {
        this.$refs['dialogActionButtons'].stopLoading();
      }
    }
  }
};
